import React, { ReactNode } from 'react';

interface CardProps {
  title: string;
  value: number;
  icon: ReactNode;
  color: string;
  bgColor: string;
}

export function Card({ title, value, icon, color, bgColor }: CardProps) {
  return (
    <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">{value}</p>
        </div>
        <div className={`p-3 rounded-full ${bgColor}`}>
          <div className={color}>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
}
